var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5772 27.5771L16.5686 38.5858L5.55986 27.5771C3.38258 25.3998 1.89984 22.6257 1.29914 19.6057C0.698438 16.5857 1.00676 13.4554 2.18511 10.6107C3.36346 7.76591 5.35892 5.33444 7.91915 3.62376C10.4794 1.91307 13.4894 1 16.5686 1C19.6477 1 22.6577 1.91307 25.2179 3.62376C27.7782 5.33444 29.7736 7.76591 30.952 10.6107C32.1303 13.4554 32.4387 16.5857 31.838 19.6057C31.2373 22.6257 29.7545 25.3998 27.5772 27.5771ZM16.5686 24.9322C18.7868 24.9322 20.9141 24.051 22.4826 22.4825C24.0512 20.914 24.9323 18.7866 24.9323 16.5684C24.9323 14.3502 24.0512 12.2228 22.4826 10.6543C20.9141 9.08578 18.7868 8.2046 16.5686 8.2046C14.3503 8.2046 12.223 9.08578 10.6545 10.6543C9.08594 12.2228 8.20475 14.3502 8.20475 16.5684C8.20475 18.7866 9.08594 20.914 10.6545 22.4825C12.223 24.051 14.3503 24.9322 16.5686 24.9322Z",
    stroke: "#E87400",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPin);
export default __webpack_public_path__ + "static/media/ico-pin.fef2701e003b10783a5ea6d0004ba9e3.svg";
export { ForwardRef as ReactComponent };